<button mat-button class="{{css}}" (click)="onClick.emit()" [disabled]="loading || disabled">
  <mat-spinner *ngIf="loading; else actions" diameter=30></mat-spinner>

  <ng-template #actions>
    <i class="{{icon}}"></i>
    <span class="text" *ngIf="label"> {{label | translate}}</span>
  </ng-template>
</button>
